/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './comparison-select.stache';
import PlayerService from 'scripts/services/player-service';

function getFavoritePlayers(playersList) {
    const favorites = PlayerService.getFavorites();
    const favouritesId = !!favorites ? favorites.serialize() : [];
    return playersList.filter(({ identifier }) =>
        favouritesId.some((favoriteId) => favoriteId === identifier),
    );
}

const playerPageUrl = window.globalSettings.pagePaths.player;

Component.extend({
    tag: 'comparison-select',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            isFetching: {
                type: 'boolean',
                value: false,
            },
            playersList: {
                Type: can.List,
                Value: can.List,
            },
            selected: {
                Type: can.List,
                Value: can.List,
            },
            searchValue: {
                type: 'string',
                value: '',
            },
            players: {
                get() {
                    const searchValue = this.attr('searchValue');
                    if (searchValue) {
                        return this.attr('playersList').filter(
                            ({ firstName, lastName }) =>
                                `${firstName} ${lastName}`
                                    .toLocaleLowerCase()
                                    .indexOf(
                                        String(searchValue).toLocaleLowerCase(),
                                    ) !== -1,
                        );
                    }

                    return this.attr('playersList');
                },
            },
            favoritePlayers: {
                get() {
                    const searchValue = this.attr('searchValue');
                    const favoriteList = getFavoritePlayers(
                        this.attr('playersList'),
                    );
                    if (searchValue) {
                        return favoriteList.filter(
                            ({ firstName, lastName }) =>
                                `${firstName} ${lastName}`
                                    .toLocaleLowerCase()
                                    .indexOf(
                                        String(searchValue).toLocaleLowerCase(),
                                    ) !== -1,
                        );
                    }

                    return favoriteList;
                },
            },
            isCompareReady: {
                get() {
                    const selected = this.attr('selected').serialize();

                    return _.filter(selected, Boolean).length === 2;
                },
            },
        },

        setSearchValue: _.debounce(function(e) {
            const searchValue = e.target.value;
            this.attr('searchValue', searchValue);
        }, 400),

        onTogglePlayer(event, $element, playerId) {
            event.preventDefault();
            event.stopPropagation();

            const isSelected = $element.is(':checked');

            if (isSelected) {
                this.dispatch('selectPlayer', [playerId]);
            } else {
                this.dispatch('resetPlayer', [playerId]);
            }
        },

        onClickClose(event) {
            event.stopPropagation();
            this.dispatch('close');
        },

        openPlayerPage(event, playerId) {
            event.preventDefault();
            window.open(can.sub(playerPageUrl, { playerId }), '_blank');
        },
    },
    helpers: {
        isSelected(playerId, options) {
            const selected = this.attr('selected').serialize();

            if (selected.some((selectedId) => selectedId == playerId)) {
                return options.fn();
            }

            return options.inverse();
        },
    },
});
